"use client";
import { useState, lazy, Suspense } from "react";
import EventHero from "./EventHero";

const VideoModal = lazy(() => import("@/components/videoModel"));

export default function EventHeroSection({
  titel,
  publish_date,
  updatedAt,
  cover,
  cover_thumbnail,
  images,
}) {
  const [modal, setModal] = useState({ open: false, url: "" });

  const isVideo = cover?.mime?.includes("video");
  const displayThumbnail = isVideo
    ? cover_thumbnail?.url || images?.[0]?.formats?.medium?.url || images?.[0]?.url
    : cover?.url;

  return (
    <>
      {modal.open && (
        <Suspense fallback={null}>
          <VideoModal
            open={modal.open}
            url={modal.url}
            onClose={() => setModal({ open: false, url: "" })}
          />
        </Suspense>
      )}

      <EventHero
        titel={titel}
        publish_date={publish_date}
        updatedAt={updatedAt}
        isVideo={isVideo}
        setModal={setModal}
        displayThumbnail={displayThumbnail}
        cover={cover}
      />
    </>
  );
}
